import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SingleTransactionDetails = () => {
  const { transactionId } = useParams();
  const decodedId = transactionId ? atob(transactionId) : transactionId;
  const id = decodedId.replace(/\D/g, ''); // Ensure we only get the numeric part
  const [transactionDetails, setTransactionDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    const fetchTransactionDetails = async () => {
      try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.transaction}${id}/`, { headers });
        const extractedColumns = Object.keys(response.data);
       
        const accountNumber = response.data.account;
        //console.log(accountNumber)
        if (accountNumber) {
          const accountResponse = await axios.get(`${API_DOMAIN}${API_ROUTES.account}${accountNumber}/`, { headers });
          const accountDetails = accountResponse.data;          
          extractedColumns.push('Account Name');          
          response.data['Account Name'] = accountDetails.name; 
         
        } 
      
      // Define which columns to exclude (if necessary)
        const excludedColumns = ['id', 'created_at', 'updated_at', 'account', 'description', 'created_by'];
        const columnsArray = extractedColumns
          .filter((column) => !excludedColumns.includes(column))
          .map((column) => ({
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
          }));

        setColumnDetails(columnsArray);
        setTransactionDetails(response.data);
      } catch (error) {
        console.error('Error fetching transaction details:', error);
      }
    };



    fetchTransactionDetails();
  }, [transactionId]);
  

  return (
    <div>
      {transactionDetails ? (
        <SingleItemDetailTemplate details={transactionDetails} columns={columns} />
      ) : (
        <p>Loading transaction details...</p>
      )}
    </div>
  );
};

export default SingleTransactionDetails;